"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JoinTheCelebration() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const stats = [{
    label: "BRUNCH & BUBBLES"
  }, {
    label: "GIFT REGISTRY OPEN"
  }, {
    label: "RSVP BY OCTOBER 1ST"
  }];
  return <section data-section-id="3995" id="join-the-celebration" className="relative bg-background text-foreground overflow-hidden min-h-[80vh] flex items-center justify-center px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_editorial_mist.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background/90 via-background/70 to-background/90" aria-hidden="true" />

      {}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: "radial-gradient(circle, var(--primary) 1px, transparent 1px)",
      backgroundSize: "32px 32px"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.08]" style={{
      backgroundImage: "repeating-linear-gradient(0deg, var(--border) 0px, var(--border) 1px, transparent 1px, transparent 4px)"
    }} aria-hidden="true" />

      {}
      {}
      <div className="absolute top-6 left-6 sm:top-8 sm:left-8 flex items-center gap-2 font-mono text-[10px] sm:text-xs uppercase tracking-widest text-muted-foreground z-10">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75" />
          <span className="relative inline-flex rounded-lg h-2 w-2 bg-primary" />
        </span>
        <span>STATUS: CELEBRATING</span>
      </div>

      {}
      <div className="absolute top-6 right-6 sm:top-8 sm:right-8 font-mono text-[10px] sm:text-xs uppercase tracking-widest text-muted-foreground z-10 text-right">
        <div>EST. NOV 2024</div>
        <div>LOS ANGELES, CA</div>
      </div>

      {}
      <div className="hidden sm:block absolute bottom-8 left-6 lg:left-8 font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground z-10" style={{
      writingMode: "vertical-rl",
      transform: "rotate(180deg)"
    }}>
        OHLSON // FAMILY ARCHIVE
      </div>

      {}
      <div className="absolute bottom-6 right-6 sm:bottom-8 sm:right-8 font-mono text-[10px] sm:text-xs uppercase tracking-widest text-muted-foreground z-10">
        // 01 — WELCOME
      </div>

      {}
      <div ref={ref} className={`relative z-10 max-w-6xl w-full mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="mb-6 flex items-center justify-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-primary">
          <span className="h-px w-8 bg-primary" />
          <span>// THE CELEBRATION</span>
          <span className="h-px w-8 bg-primary" />
        </div>

        {}
        <h2 className="font-default uppercase font-bold leading-[0.9] tracking-tight text-foreground" style={{
        fontSize: "clamp(3.5rem, 12vw, 10rem)"
      }}>
          JOIN THE CELEBRATION
          <span className="text-primary">.</span>
        </h2>

        {}
        <p className="mt-8 text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto font-default">
          We are so excited to welcome our little one. Join us for a morning of love, laughter, and brunch.
        </p>

        {}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-mono uppercase tracking-widest text-sm px-8 h-14 rounded-md">
            <Link to="/EventDetailsPage">
              [ VIEW REGISTRY
              <ArrowRight className="ml-1 size-4" />
              ]
            </Link>
          </Button>

          <Button asChild size="lg" variant="outline" className="border-primary/30 bg-transparent text-primary hover:bg-primary/5 hover:text-primary font-mono uppercase tracking-widest text-sm px-8 h-14 rounded-md">
            <Link to="/EventDetailsPage">
              <Phone className="size-4" />
              EVENT DETAILS
            </Link>
          </Button>
        </div>

        {}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-4 gap-y-3 font-mono text-[10px] sm:text-xs uppercase tracking-[0.2em] text-muted-foreground">
          {stats.map((stat, i) => <div data-index={i} key={i} className="flex items-center gap-x-4">
              {i > 0 && <span className="text-primary select-none" aria-hidden="true">
                  +
                </span>}
              <span>{stat.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}